'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _Modal = require('./Modal.scss');

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(Modal, _Component);

    function Modal() {
        (0, _classCallCheck3.default)(this, Modal);
        return (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).apply(this, arguments));
    }

    (0, _createClass3.default)(Modal, [{
        key: 'render',


        // Do NOT add a shouldComponentUpdate method.  It will break the children

        value: function render() {
            var _props = this.props,
                body = _props.body,
                bodyClassName = _props.bodyClassName,
                contentLabel = _props.contentLabel,
                footer = _props.footer,
                footerClassName = _props.footerClassName,
                header = _props.header,
                headerClassName = _props.headerClassName,
                large = _props.large,
                leftImage = _props.leftImage,
                modalRightClassName = _props.modalRightClassName,
                modalSize = _props.modalSize,
                show = _props.show,
                small = _props.small;


            var classes = (0, _classnames2.default)(_Modal2.default['modal-content'], (0, _defineProperty3.default)({}, _Modal2.default['modal-content-large'], large), (0, _defineProperty3.default)({}, _Modal2.default['modal-content-small'], small), (0, _defineProperty3.default)({}, modalSize, modalSize), (0, _defineProperty3.default)({}, _Modal2.default['modal-content-size'], !large && !small && !modalSize));

            var rightModalClasses = (0, _classnames2.default)(_Modal2.default['modal-right'], modalRightClassName);

            var footerClasses = (0, _classnames2.default)(_Modal2.default['modal-footer'], footerClassName);
            var bodyClasses = (0, _classnames2.default)(_Modal2.default['modal-body'], bodyClassName || _Modal2.default['modal-body-default']);
            var headerClasses = (0, _classnames2.default)(_Modal2.default['modal-header'], headerClassName || _Modal2.default['modal-header-default']);

            return (0, _jsx3.default)(_reactModal2.default, {
                className: {
                    afterOpen: _Modal2.default['modal-content--after-open'] || '',
                    base: classes,
                    beforeClose: _Modal2.default['modal-content--before-close'] || ''
                },
                bodyOpenClassName: _Modal2.default['ReactModal__Body--open'],
                closeTimeoutMS: 100,
                contentLabel: contentLabel,
                isOpen: show,
                overlayClassName: {
                    afterOpen: _Modal2.default['modal-overlay--after-open'] || '',
                    base: '' + _Modal2.default['modal-overlay'],
                    beforeClose: _Modal2.default['modal-overlay--before-close'] || ''
                }
            }, void 0, leftImage && (0, _jsx3.default)('div', {
                className: _Modal2.default['modal-leftImage']
            }, void 0, leftImage), (0, _jsx3.default)('div', {
                className: rightModalClasses
            }, void 0, header && (0, _jsx3.default)('div', {
                className: headerClasses
            }, void 0, header), body && (0, _jsx3.default)('div', {
                className: bodyClasses
            }, void 0, body), footer && (0, _jsx3.default)('div', {
                className: footerClasses
            }, void 0, footer)));
        }
    }]);
    return Modal;
}(_react.Component), _class.defaultProps = {
    body: null,
    footer: null,
    header: null,
    large: false,
    leftImage: null,
    show: false,
    small: false
}, _temp);
exports.default = Modal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/Shared/Modal.js
// module id = ub8h
// module chunks = 60